import { render, staticRenderFns } from "./layout-info-content-window-return.vue?vue&type=template&id=8da82caa&scoped=true&"
import script from "./layout-info-content-window-return.vue?vue&type=script&lang=js&"
export * from "./layout-info-content-window-return.vue?vue&type=script&lang=js&"
import style0 from "./layout-info-content-window-return.vue?vue&type=style&index=0&id=8da82caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da82caa",
  null
  
)

export default component.exports